import { render } from "./WorkspaceView.vue?vue&type=template&id=d74d4e1c&scoped=true&ts=true"
import script from "./WorkspaceView.vue?vue&type=script&lang=ts"
export * from "./WorkspaceView.vue?vue&type=script&lang=ts"

import "./WorkspaceView.vue?vue&type=style&index=0&id=d74d4e1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74d4e1c"]])

export default __exports__